import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from 'api/rtk-api'
import { Card, LabelValueRow, Tabs } from 'components/core-v2'
import { useParams } from 'react-router-dom'

import { TENANT } from '@/const'

import { Loading } from './loading'

export const DetailsStrategyTab = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })
  if (isLoading) return <Loading />

  const { strategyTemplateName } = data.account
  const strategyName = strategyTemplateName || 'Continuous Protection (Dominion)'
  const { leverageRatio } = data.account.strategy
  const { rebalancingDefinition } = data.account.portfolio

  return (
    <Tabs.Panel value="strategy">
      <Card.Wrapper>
        <LabelValueRow label="Type" value={strategyName} />
        {leverageRatio !== undefined && (
          <LabelValueRow label="Leverage ratio" value={leverageRatio} />
        )}
        <LabelValueRow label="Rebalancing type" value={rebalancingDefinition.type} />
        <LabelValueRow showBottomBorder label="Frequency" value={rebalancingDefinition.frequency} />
      </Card.Wrapper>
    </Tabs.Panel>
  )
}
